import { bbox, circle, point } from '@turf/turf';
import { getJson, saveJson } from './offline/cache.service';

/**
 * @param {number} padding <optional> horizontal and vertical padding in miles (from center to corner)
 * @returns user's current GPS location. Format: 
 * 	{center: [lat,long], bounds?: {xmin:number, ymin:number, xmax:number, ymax:number} | null }
 * 
 * 	null if not found
 */
export const getUserCurrentLocation = async (padding) => {
	const location = await getGPSLocation();
	if (!location) return null;

	if (!padding) return {center: location, bounds: null};

	else {
		// Center of Arkansas (for debugging)
		//  return {
		//  	center: [34.75300777740124, -92.31905884225677],
		//  	bounds: {
		//  		xmin: -92.67136651815315,
		//  		ymin: 34.463544611113655,
		//  		xmax: -91.96675116636038,
		//  		ymax: 35.04247094368882
		//  	}
		//  }
		const center = point([location[1], location[0]]);
		const [xmin, ymin, xmax, ymax] = bbox(circle(center, padding, {units: 'miles'}));
		return {center: location, bounds: { xmin, ymin, xmax, ymax }}
	}
}

export const cacheUserLocation = (loc) => {
	saveJson('location', loc);
}

export const getCachedUserLocation = () => {
	return getJson('location');
}

/**
 * Get device's GPS position
 * @returns Promise<[lat,lon]> or null if not available
 */
const getGPSLocation = () => {
	if (!navigator.geolocation ||  !navigator.geolocation.getCurrentPosition) return null;
	return new Promise(resolve => {
		navigator.geolocation.getCurrentPosition(
			pos => {
				const crd = pos.coords;
				resolve([crd.latitude, crd.longitude])
			},
			() => resolve(null),
			{
				enableHighAccuracy: true,
				timeout: 5000,
				maximumAge: 0
			}
		)
	})
}

export const milesToFeet = (miles) => {
	return Math.round(miles * 5280);
}